import { useState } from 'react';
import FestivalLinks from '../../../components/FestLinks/FestLinks';
import Footer from '../../../components/Footer/Footer';
import InnerNav from '../../../components/InnerNav/InnerNav';
import Zodiac from '../../../components/ZodiacSign/Zodiac';
import './Dash.scss';


const dashavatara = [
  { id: 1, name: 'Matsya', img: 'https://cdn.shopify.com/s/files/1/0815/1000/7089/files/mastya_2_480x480.jpg?v=1702286817', info: 'Matsya, the fish, saved the ancient scriptures and the sages from a great flood.' },
  { id: 2, name: 'Kurma', img: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQ2DQvmIAD6xqLjoyHmSItMW2pKFx3B4jCffQ&s', info: 'Kurma, the tortoise, helped churn the ocean to retrieve divine treasures.' },
  { id: 3, name: 'Varaha', img: 'https://www.shridharam.com/wp-content/uploads/2023/10/ShriVarahAvtar.jpg', info: 'Varaha, the boar, rescued Earth from the depths of the cosmic ocean.' },
  { id: 4, name: 'Narasimha', img: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTB9PqnpdOBA8HSg4souHe0-2ePL-JgiN6gJA&s', info: 'Narasimha, the man-lion, destroyed the demon king Hiranyakashipu.' },
  { id: 5, name: 'Vamana', img: 'https://cdn.shopify.com/s/files/1/0815/1000/7089/files/vamana-avatar-of-vishnu-2.jpg', info: 'Vamana, the dwarf, humbled the demon king Bali by covering the universe in three steps.' },
  { id: 6, name: 'Parashurama', img: 'https://assets.mypandit.com/wp-content/uploads/2021/06/Parshuram_Jayanti.webp', info: 'Parashurama, the warrior sage, rid the earth of corrupt Kshatriyas.' },
  { id: 7, name: 'Rama', img: 'https://iskconchowpatty.com/wp-content/uploads/2024/01/Maryada-Purushottam-Ram-jpg.webp', info: 'Rama, the prince of Ayodhya, upheld dharma and defeated Ravana.' },
  { id: 8, name: 'Krishna', img: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRz5gN3RVlE0x3k_P7wsXLCyKTbnQkqWG713Q&s', info: 'Krishna guided Arjuna in the Mahabharata and performed many miracles.' },
  { id: 9, name: 'Buddha', img: 'https://cdn.shopify.com/s/files/1/0054/5662/5728/files/1569723285tebmp-af_480x480.jpg?v=1621414695', info: 'Buddha taught compassion and renunciation to overcome suffering.' },
  { id: 10, name: 'Kalki', img: 'https://i.pinimg.com/736x/9f/6c/f6/9f6cf61d16cdba9a23b168dd74b0995f.jpg', info: 'Kalki, the future avatar, will appear to end the age of darkness and restore righteousness.' },
];

const Dash = () => {
  const [selectedAvatar, setSelectedAvatar] = useState(null);

  const closePopup = () => setSelectedAvatar(null);

  return (
    <div className="dash-container">
      <InnerNav />
      <div className="dash-content">
        <Zodiac />

        <div className="god-header">
          <h4>Dashavatara - 10 Incarnations of Lord Vishnu</h4>
        </div>

        <div className="god-grid">
          {dashavatara.map((avatar) => (
            <div className="god-card" key={avatar.id} onClick={() => setSelectedAvatar(avatar)}>
              <img src={avatar.img} alt={avatar.name} />
              <p>{avatar.name}</p>
            </div>
          ))}
        </div>

        {selectedAvatar && (
          <div className="avatar-popup" onClick={closePopup}>
            <div className="avatar-popup-inner" onClick={(e) => e.stopPropagation()}>
              <button className="close-btn" onClick={closePopup}>×</button>
              <h3>{selectedAvatar.name}</h3>
              <img src={selectedAvatar.img} alt={selectedAvatar.name} />
              <p>{selectedAvatar.info}</p>
            </div>
          </div>
        )}

        <FestivalLinks />
      </div>
      <Footer />
    </div>
  );
};

export default Dash;